var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAid = function SvgAid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_13609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22206 12.7781H2.36095C2.17677 12.7781 2.00014 12.7049 1.8699 12.5747C1.73967 12.4445 1.6665 12.2678 1.6665 12.0837V7.91699C1.6665 7.73281 1.73967 7.55618 1.8699 7.42595C2.00014 7.29571 2.17677 7.22255 2.36095 7.22255H7.22206V2.36144C7.22206 2.17726 7.29522 2.00062 7.42546 1.87039C7.55569 1.74016 7.73233 1.66699 7.9165 1.66699H12.0832C12.2673 1.66699 12.444 1.74016 12.5742 1.87039C12.7045 2.00062 12.7776 2.17726 12.7776 2.36144V7.22255H17.6387C17.8229 7.22255 17.9995 7.29571 18.1298 7.42595C18.26 7.55618 18.3332 7.73281 18.3332 7.91699V12.0837C18.3332 12.2678 18.26 12.4445 18.1298 12.5747C17.9995 12.7049 17.8229 12.7781 17.6387 12.7781H12.7776V17.6392C12.7776 17.8234 12.7045 18 12.5742 18.1303C12.444 18.2605 12.2673 18.3337 12.0832 18.3337H7.9165C7.73233 18.3337 7.55569 18.2605 7.42546 18.1303C7.29522 18 7.22206 17.8234 7.22206 17.6392V12.7781Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_13609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgAid;